import '../../../styles/dataPage.scss';
import React, { useEffect, useState } from 'react';
import { useSupplierStore } from '@ar/stores/SupplierStore';
import { useFlags } from 'launchdarkly-react-client-sdk';
// import { Navigate } from 'react-router-dom';
// import { ARRoutePaths } from '@v2/constants/EPaths';
import { ARRoutePaths } from '@v2/constants/EPaths';
import { Navigate } from 'react-router-dom';
import { getGpoId } from '@v2/utils/GPOUtils';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';
import { getAnalyticsDashboardUrl } from '@/ar/network/AccountsReceivable.network';

/**
 * Supplier Dashboard page
 *
 * @returns JSX Element
 */
export const SupplierHomePage: React.FC = () => {
    useDocumentTitle('Home - Notch');
    const { enableSupplierAppDashboard } = useFlags();
    const [dashboardUrl, setDashboardUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { supplierLoginData } = useSupplierStore();
    const gpoId = getGpoId(supplierLoginData);
    const [error, setError] = useState<string | null>(null);
    useEffect(() => {
        if (!enableSupplierAppDashboard) return;

        setIsLoading(true);
        getAnalyticsDashboardUrl(supplierLoginData.supplier_id, gpoId)
            .then((url) => {
                setDashboardUrl(url);
            })
            .catch((err) => {
                console.error('Failed to fetch dashboard URL:', err);
                setError('Could not load dashboard');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [enableSupplierAppDashboard, supplierLoginData.supplier_id]);

    if (!enableSupplierAppDashboard) {
        return <Navigate to={`/${ARRoutePaths.AR_HOME}`} replace />;
    }
    if (isLoading) {
        return <div>Loading dashboard…</div>;
    }
    if (!dashboardUrl) {
        return <div>Loading...</div>;
    }
    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            {dashboardUrl && (
                <iframe
                    src={dashboardUrl}
                    title="Analytics Dashboard"
                    style={{ flex: 1, border: 'none' }}/>
            )}
        </div>
    );
};
